import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';

import type RoomControlPageModel from 'admin-panel/models/room-control/page';

export default class RoomControlSectionModel extends Model {
  @belongsTo('room-control/page')
  declare roomControlPage: AsyncBelongsTo<RoomControlPageModel>;

  @attr
  declare sectionType: string;

  @attr
  declare icon: string;

  @attr
  declare position: number;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/section': RoomControlSectionModel;
  }
}
